import React from 'react'
import MechanicPage from './Mechanics'
import LoginPage from './Login'
import RegisterPage from './Login/RegisterPage'
import Layout from '../Layout'
import ProjectPage from './Projects'
import AdminPage from './Admin'
// import './index.css'

export const PageItems = {
    LOGIN: 1,
    MECHANIC: 2,
    PROJECTS: 3,
    REGISTER: 4,
    ADMIN: 5,
}

const Pages = (props) => {
    if (props.page === PageItems.LOGIN) {
        return <LoginPage />
    }

    if (props.page === PageItems.REGISTER) {
        return <RegisterPage />
    }

    let content = null

    if (props.page === PageItems.MECHANIC) {
        content = <MechanicPage />
    }

    if (props.page === PageItems.PROJECTS) {
        content = <ProjectPage />
    }

    if (props.page === PageItems.ADMIN) {
        content = <AdminPage />
    }

    return <Layout>{content}</Layout>
}

export default Pages
